import React from 'react'

export const CalendarVector = () => (
  <svg
    className="MIRECO-calendar"
    version="1.1"
    viewBox="0 0 6.3499998 6.3499998"
    height="24"
    width="24"
  >
    <g
      transform="translate(0,-290.65)"
    >
      <rect
        style={{
          fill: 'none',
          fillOpacity: 0.271255,
          stroke: '#333333',
          strokeWidth: 0.396875,
          strokeLinecap: 'round',
          strokeLinejoin: 'round',
          strokeDashoffset: 5.39717,
        }}
        width="3.7041667"
        height="3.1750121"
        x="1.3229166"
        y="292.23749"
        rx="0.52916664"
      />
      <path
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: 0.396875,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        d="M 1.3229167,293.29583 H 5.0270833"
      />
      <path
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: 0.1984375,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        d="m 2.5135417,293.29583 v 2.11667"
      />
      <path
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: 0.1984375,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        d="m 3.8364583,293.29583 v 2.11667"
      />
      <path
        style={{
          fill: 'none',
          stroke: '#333333',
          strokeWidth: 0.1984375,
          strokeLinecap: 'butt',
          strokeLinejoin: 'miter',
          strokeMiterlimit: 4,
          strokeDasharray: 'none',
          strokeOpacity: 1,
        }}
        d="M 1.3229167,294.35417 H 5.0270833"
      />
    </g>
  </svg>
)
